// extracted by mini-css-extract-plugin
export default {"middleContainer":"styles_middleContainer__2aDkw","clickable":"styles_clickable__3YEmV","countdownContainer":"styles_countdownContainer__6-xxd","counter":"styles_counter__AKQ1E"};